<div class="dashboard">
    <div class="navigation-bar" [@navBar]="navCollapsed ? 'afterCollapsedNav':'beforeCollapsed'">
        <div class="nav-header">
            <div class="nav-title" [@navBar]="navCollapsed ? 'afterCollapsedHidden':'beforeCollapsed'">
                <h3 style="overflow: hidden;">Seng Hin Rubber</h3>
            </div>
            <div class="glyphicon glyphicon-list" (click)="navCollapsed = !navCollapsed"></div>
        </div>
    </div>

    <div class="dashboard-section" [@navBar]="navCollapsed ? 'afterCollapsedDashboard':'beforeCollapsed'">
        <table class="contact-table">
            <tr>
                <th class="table-no">No.</th>
                <th class="table-name">Name</th>
                <th class="table-email">Email</th>
                <th class="table-subject">Subject</th>
                <th class="table-action">Action</th>    
            </tr>
            <tr *ngFor="let contact of contactList; let i = index">
                <td>{{ i+1 }}</td>
                <td>{{ contact.name }}</td>
                <td>{{ contact.email }}
                <td>{{ contact.subject }}</td>
                <td><button (click)="checkContact(i)">Check</button></td>
                <!-- <td><button [routerLink]="['/dashboard/check', '{{contact}}']">Check</button></td> -->
            </tr>    
        </table>
    </div>
</div>